import { ActionLookupReducer, lookupTableReducer } from 'Modules/core/redux';

import { monitoringActions } from './actions';
import { MonitoringElement } from '../../api';


const defaultState: MonitoringElement[] = [];

const actionLookup: ActionLookupReducer<MonitoringElement[]> = {
    [`${monitoringActions.setMonitoringList}`]: (_, list: MonitoringElement[]) => list,
};

export const reducer = lookupTableReducer(defaultState, actionLookup);
